module.exports = __webpack_public_path__ + "img/swiper3.55c4e332.png";